import styled from 'styled-components';

export const UseTermsStyle = styled.div`
    display: flex;
    max-height: calc(100vh - 12rem - 15vh);
    flex-direction: column;

    padding: 1rem;
`
